import { checkDate } from "../../functions/checkDate";

export default function ButtonsBar({ formattedDate, headerInfo }) {
  return (
    <div>
      <div>{checkDate(formattedDate, "monthsFullName")}</div>
      <div>{headerInfo.ter && headerInfo.ter.name}</div>
    </div>
  );
}
